<ng-content select="glxy-table-content-header" />
<div
  class="table-loading--wrapper"
  [ngClass]="{
    'table-is-loading': dataSource?.loading$ | async,
  }"
  >
  <div
    matSort
    (matSortChange)="updateSorting($event)"
    class="glxy-table-scrollable show-sticky-shadow-end"
    #scrollContainer
    >
    <div class="glxy-table-scrollable" [hidden]="displayOption() === 'grid'">
      <ng-content select=":not([glxy-grid-content])" />
      @for (col of columns; track col.id) {
        <ng-container [matColumnDef]="col.id">
          @if (col.sortable) {
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ col.title }}</th>
          } @else {
            <th mat-header-cell *matHeaderCellDef>{{ col.title }}</th>
          }
          <td mat-cell *matCellDef="let row">
            <glxy-table-model-driven-cell [cellData]="row.data[col.id]" />
          </td>
        </ng-container>
      }
    </div>
    <div [hidden]="displayOption() === 'list'">
      <glxy-table-grid-view [minWidth]="gridCardMinWidth" [cardDirective]="cardDirective">
        <ng-content select="[glxy-grid-content]" />
      </glxy-table-grid-view>
    </div>
  </div>
  @if (dataSource?.loading$ | async) {
    <div class="loading-message">
      <glxy-loading-spinner class="loading-spinner" size="large" fullHeight fullWidth />
    </div>
  }
</div>
@if (showFooter && dataSource) {
  <glxy-table-content-footer
    [id]="id"
    [dataSource]="dataSource"
    [pageSizeOptions]="pageSizeOptions"
    [pageSize]="pageSize"
    />
}
